

export const ESTABLECIMIENTOS = [

  {
    nombre: "ALBORADA",
    ip    : "192.168.3.237"
  },

  {
    nombre: "SAN JUAN",
    ip    : "192.168.3.241"
  },

  {
    nombre: "KENNEDY",
    ip    : "192.168.3.242"
  },

  {
    nombre: "SAMBORONDON",
    ip    : "192.168.3.243"
  },

  {
    nombre: "DESARROLLO",
    ip    : "localhost"
  },

  {
    nombre: "PRUEBAS",
    ip    : "192.168.3.240"
  },

]